import { useParams } from '@tanstack/react-router';
import { lazy } from 'react';
import { GarageGate } from '../lib/gate.js';

const InterventionScreen = lazy(() => import('../screens/InterventionScreen.js'));

/** Fiche intervention (espace garage). */
export default function InterventionPage() {
  const { interventionId } = useParams({ strict: false });
  return <GarageGate>{interventionId ? <InterventionScreen key={interventionId} interventionId={interventionId} /> : null}</GarageGate>;
}
